import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

type MapHash = {
    spotterId?: string;
    hash: string;
};

export const spotterIdHash = (spotterId: string) => `spotter/${spotterId}`;

export const useSpotterHash: () => MapHash = () => {
    const { hash } = useLocation();

    const mapHash = useMemo(() => {
        const spotterMatch = hash.match(/^#spotter\/(.*)/);
        if (spotterMatch) {
            return { spotterId: spotterMatch[1] };
        }

        return {};
    }, [hash]);

    return { ...mapHash, hash };
};
